import React from 'react';
import { useAsync } from 'helpers/hooks';
import { useTranslation } from 'react-i18next';
import { ToastContext } from 'contexts';
import { useAuth } from 'providers/AuthProvider';
import { useHistory } from 'react-router';
import { checkToken, TokenTypes } from 'helpers/tokens';
import { TokenExpiredError, TokenInvalidError } from 'helpers/tokens/errors';

const getRegistrationToken = () => {
  const token = window.location.hash.substr(1);
  return token.length ? token : null;
};

export default () => {
  const { t } = useTranslation();
  const { triggerToast } = React.useContext(ToastContext);
  const { logout } = useAuth();
  const history = useHistory();

  const registrationToken = React.useMemo(getRegistrationToken, [getRegistrationToken]);

  const isTokenMissing = registrationToken === null;

  const [checkTokenResult] = useAsync(
    React.useCallback(
      () => checkToken(registrationToken, TokenTypes.COMPLETE_SETUP),
      [registrationToken]
    ),
    !isTokenMissing
  );

  if (isTokenMissing) {
    history.push('/');
  }

  if (checkTokenResult.isError) {
    if (TokenExpiredError.isInstance(checkTokenResult.error)) {
      triggerToast({ message: t('login.expired_otp_link') });
      history.push('/completeSetup/resend', { registrationToken });
    } else if (TokenInvalidError.isInstance(checkTokenResult.error)) {
      triggerToast({ message: t('login.invalid_otp_link') });
      history.push('/');
    } else {
      history.push('/');
    }
  }

  if (checkTokenResult.isSuccess) {
    const { data: user } = checkTokenResult;

    logout();

    if (!user.hasAcceptedInvitation) {
      history.push(`/register`, {
        registrationToken,
        email: user.email,
        userId: user.id,
      });
    } else {
      history.push('/login');
    }
  }

  return checkTokenResult;
};
